/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Min_ItemsInputs */

const en_orders_min_items = /** @type {(inputs: Orders_Min_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min items`)
};

const es_orders_min_items = /** @type {(inputs: Orders_Min_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Articulos min`)
};

/**
* | output |
* | --- |
* | "Min items" |
*
* @param {Orders_Min_ItemsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_min_items = /** @type {((inputs?: Orders_Min_ItemsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Min_ItemsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_min_items(inputs)
	return es_orders_min_items(inputs)
});